import { Link } from 'react-router-dom';
import { Sparkles, ArrowLeft, Mail, MapPin, Building } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-indigo-700 rounded-xl flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <span className="text-xl font-serif font-bold text-slate-900">StatsXY</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-indigo-600">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-serif font-bold text-slate-900 mb-2">
            Contact Us
          </h1>
          <p className="text-lg text-slate-600 mb-8">
            Get in touch with the StatsXY team
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="space-y-6">
              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Building className="w-6 h-6 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">Operated by</h3>
                    <p className="text-slate-700 font-medium">Fee Doree Ltd</p>
                  </div>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">Address</h3>
                    <p className="text-slate-700">Royal Road, Hermitage</p>
                    <p className="text-slate-700">Phoenix, Mauritius</p>
                  </div>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">Email</h3>
                    <a 
                      href="mailto:feedoreeltd@gmail.com" 
                      className="text-indigo-600 hover:text-indigo-800 font-medium"
                    >
                      feedoreeltd@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Support Info */}
            <div className="space-y-6">
              <div className="bg-indigo-50 rounded-xl p-6 border border-indigo-200">
                <h3 className="font-semibold text-indigo-900 mb-3">Support Hours</h3>
                <p className="text-indigo-800 mb-2">
                  We aim to respond to all inquiries within 24-48 hours.
                </p>
                <p className="text-indigo-700 text-sm">
                  For technical support, please include details about your issue and any error messages you've encountered.
                </p>
              </div>

              <div className="bg-green-50 rounded-xl p-6 border border-green-200">
                <h3 className="font-semibold text-green-900 mb-3">Common Inquiries</h3>
                <ul className="text-green-800 space-y-2 text-sm">
                  <li>• Account and subscription questions</li>
                  <li>• Technical issues with the platform</li>
                  <li>• Data and privacy concerns</li>
                  <li>• Feature requests and feedback</li>
                  <li>• Academic partnerships</li>
                </ul>
              </div>

              <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
                <h3 className="font-semibold text-amber-900 mb-3">Before Contacting Us</h3>
                <p className="text-amber-800 text-sm">
                  Please review our <Link to="/terms" className="underline hover:text-amber-900">Terms & Conditions</Link> and <Link to="/privacy" className="underline hover:text-amber-900">Privacy Policy</Link> for answers to common questions about data handling, payments, and platform usage.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 text-center text-sm text-slate-500">
          <Link to="/terms" className="hover:text-indigo-600 mx-3">Terms & Conditions</Link>
          <span>|</span>
          <Link to="/privacy" className="hover:text-indigo-600 mx-3">Privacy Policy</Link>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;
